export default "<p>\r\n  setpasswordcomp works!\r\n</p>\r\n";